import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { RootState } from "../../../../redux/rootReducers";
import {
  getClientUserSchedulingListAction,
  resetClientUserSchedulingList,
  resetClientUserSchedulingListTotal,
  resetSchedulingError,
  resetSchedulingMessage,
  resetSchedulingStatusCode,
  resetSchedulingSuccess,
} from "../../../../redux/scheduling";
import {
  getAssignedClientsToUserAction,
  resetSession,
} from "../../../../redux/auth";
import {
  CommonHeader,
  DropDown,
  EmptyListPage,
  ErrorSuccessModal,
  Loader,
} from "../../../../components/commons";
import ClientUserScheduleCalendarView from "./ClientUserScheduleCalenderView";
import {
  ClientType,
  LoginResponseType,
} from "../../../../redux/auth/authTypes";
import { GetAssignedClientsToUserPayloadType } from "../../../../commonTypes/authTypes";
import ReportsDateSelect from "../../../../components/commons/ReportsDateSelect/ReportsDateSelect";
import {
  formatDate,
  getCurrentMonthDates,
  handleDate,
  reverseDateFormat,
} from "../../../../utils/commonFunctions";
import { GetClientUserSchedulingListPayloadType } from "../../../../commonTypes/schedulingTypes";
import { ClientUserSchedulingListType } from "../../../../redux/scheduling/schedulingTypes";
import "../style.scss";
import useDebounce from "../../../../customHooks/useDebounce";
import { getClientDirectoryListAction } from "../../../../redux/clientDirectory";
import Select from "react-select";

type AppProps = {
  token: string | null;
  fetching: boolean;
  message: string | null;
  error: string | null;
  statusCode: number | null;
  success: number | null;
  totalCount: number;
  loginData: LoginResponseType;
  clientList: ClientType[] | [];
  clientUserSchedulingList: ClientUserSchedulingListType[] | [];
  type?: string;
  totalClientsCount: any;
  dispatchResetSession: () => void;
  dispatchResetSchedulingError: () => void;
  dispatchResetSchedulingSuccess: () => void;
  dispatchResetSchedulingMessage: () => void;
  dispatchResetSchedulingStatusCode: () => void;
  dispatchResetClientUserSchedulingListTotal: () => void;
  dispatchResetClientUserSchedulingList: () => void;
  dispatchGetClientUserSchedulingList: (
    data: GetClientUserSchedulingListPayloadType
  ) => void;
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => void;
  dispatchGetAllClientAction: (data: getAllClientPayload) => void;
};

export type DropDownItemType = {
  value: number | undefined;
  label: string | undefined;
};
export type ClientListType = {
  value: number |null;
  label: string | null;
};
type getAllClientPayload = {
  token: string;
  offset: number;
  limit: number;
  searchValue: string | undefined;
};
const ClientVsUserScheduling = ({
  token,
  fetching,
  message,
  error,
  type,
  statusCode,
  success,
  totalCount,
  loginData,
  clientList,
  clientUserSchedulingList,
  totalClientsCount,
  dispatchResetClientUserSchedulingList,
  dispatchResetClientUserSchedulingListTotal,
  dispatchResetSession,
  dispatchResetSchedulingError,
  dispatchResetSchedulingSuccess,
  dispatchResetSchedulingMessage,
  dispatchResetSchedulingStatusCode,
  dispatchGetClientUserSchedulingList,
  dispatchGetAssignedClientsToUserAction,
  dispatchGetAllClientAction,
}: AppProps) => {
  const { start, end } = getCurrentMonthDates();
  const [offset, setOffset] = useState<number>(0);
  const [limit, setLimit] = useState<number>(20);
  const [showData, setShowData] = useState(false);
  const [clientSelected, setClientSelected] = useState<any>({
    value: null,
    label: "Select Client",
  });
  const [selectedClient, setSelectedClient] = useState("");
  const [finalClientList, setFinalClientList] = useState<
    DropDownItemType[] | []
  >([]);
  const [displayStartDate, setDisplayStartDate] = useState("");
  const [displayEndDate, setDisplayEndDate] = useState("");
  const [startDate, setStartDate] = useState(start);
  const [endDate, setEndDate] = useState(end);
  const [toggle, setToggle] = useState<boolean>(false);
  const [text, setText] = useState<string>("");
  const [loadCondition, setLoadCondition] = useState(true);

  useEffect(() => {
    dispatchResetSchedulingError();
    dispatchResetSchedulingSuccess();
    dispatchResetSchedulingMessage();
    dispatchResetSchedulingStatusCode();
    dispatchResetClientUserSchedulingList();
    dispatchResetClientUserSchedulingListTotal();
  }, []);


  useEffect(() => {
    if (token) {
      if (offset <= +totalClientsCount) {
        let finalClientData = {
          token,
          offset,
          limit,
          searchValue: text,
          status: 1,
        };
        dispatchGetAllClientAction(finalClientData);
      }
    }
  }, [offset]);

  const fetchNewData = (search: string) => {
    if (token) {
      const finalData = {
        token,
        offset,
        limit,
        searchValue: text,
        status: 1,
      };
      dispatchGetAllClientAction(finalData);
    }
  };

  useDebounce(
    () => {
      fetchNewData(text);
    },
    500,
    [text]
  );

  useEffect(() => {
    if (clientList?.length > 0) {
      if (offset <= +totalClientsCount) {
        let finalClientData = clientList?.map((user: any) => {
          return {
            value: user.client_code,
            label: `(${user.client_code}) ${user.company_name}`,
          };
        });

        if (offset > 0) {
          setFinalClientList([...finalClientList, ...finalClientData]);
        } else {
          setFinalClientList([...finalClientData]);
        }
      }
    }
  }, [clientList]);


  const checkBottom = (e: any) => {
    setLoadCondition(false);
    setOffset((prv) => prv + limit);
  };
  const onMenuClose = () => setLoadCondition(true);

  const handleStartDateChange = (date: string) => {
    const value = handleDate(date);
    setStartDate(value);
  };
  const handleEndDateChange = (date: string) => {
    const value = handleDate(date);
    setEndDate(value);
  };
  const handleChangeClient = (client: any) => {
    setClientSelected(client);
  };

  const handleSubmit = () => {
    setShowData(true);
    dispatchResetClientUserSchedulingList();
    if (token) {
      let finalData = {
        token,
        client_code: clientSelected?.value,
        start_date: startDate ? reverseDateFormat(startDate) : "",
        end_date: endDate ? reverseDateFormat(endDate) : "",
      };
      dispatchGetClientUserSchedulingList(finalData);
      setDisplayStartDate(handleDate(startDate));
      setDisplayEndDate(handleDate(endDate));
    }
  };

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => {
              dispatchResetSession();
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetSchedulingError();
              dispatchResetSchedulingSuccess();
              dispatchResetSchedulingMessage();
            }}
          />
        );
      }
    }

    return false;
  };

  return (
    <>
      <div className="col-md-6">
        <CommonHeader title="Client-User Scheduling" />
      </div>
      <div className="col-md-12 mt-4">
        <div className="new-table-card">
          <div className="header pb-0">
            <div className="left-header">
              <div className="heading">
                Client-User Scheduling List
                {!showData ? (
                  <> </>
                ) : (
                  <>
                    {!fetching && (
                      <div className="sub-heading mt-0">{`Total ${
                        totalCount ? totalCount : 0
                      } schedules found`}</div>
                    )}
                  </>
                )}
              </div>
            </div>
          </div>
          <div>
            <div className="d-flex align-items-start">
              <div className="col-md-2 pl-3 form-group d-flex flex-column p-0">
                <label className="mb-1">Select Client</label>
                <Select
                  options={finalClientList}
                  value={clientSelected}
                  cacheOptions
                  onChange={handleChangeClient}
                  onMenuScrollToBottom={(e: any) => checkBottom(e)}
                  onInputChange={(e: string) => {
                    setLoadCondition(false);
                    setText(e);
                    setOffset(0);
                  }}
                  onMenuClose={onMenuClose}
                  isLoading={!loadCondition && fetching}
                />
              </div>
              <div className="form-group ml-3">
                <label className="mb-1">Date</label>
                <div>
                  <ReportsDateSelect
                    setToggle={setToggle}
                    toggle={toggle}
                    startDate={startDate ? startDate : ""}
                    endDate={endDate ? endDate : ""}
                    handleStartDateChange={handleStartDateChange}
                    handleEndDateChange={handleEndDateChange}
                    type={"schedulingReport"}
                  />
                </div>
              </div>
              <div className="ml-3" style={{ marginTop: "29px" }}>
                {/* <label className='mt-1'></label> */}
                <button
                  className="btn btn-primary pl-3 pb-2"
                  //   disabled={!clientSelected?.value}
                  disabled={
                    !clientSelected?.value ||
                    !startDate?.length ||
                    !endDate?.length
                  }
                  onClick={handleSubmit}
                >
                  Apply
                </button>
              </div>
            </div>
          </div>
          {!showData ? (
            <div className="mt-5">
              <EmptyListPage title="No List Found!" text="" imageWidth="30%" />
            </div>
          ) : (
            <div>
              <ClientUserScheduleCalendarView
                data={clientUserSchedulingList}
                fetching={fetching}
                totalCount={totalCount}
                startDate={startDate}
                endDate={endDate}
                displayStartDate={displayStartDate}
                displayEndDate={displayEndDate}
                clientSelected={clientSelected}
              />
            </div>
          )}
        </div>
      </div>
      {handleErrorModal()}
    </>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  message: state.scheduling.message,
  error: state.scheduling.error,
  statusCode: state.scheduling.statusCode,
  success: state.scheduling.success,
  fetching: state.scheduling.fetching,
  clientUserSchedulingList: state.scheduling.clientUserSchedulingList,
  totalCount: state.scheduling.clientUserSchedulingListTotal,
  totalClientsCount: state.clientDirectory.totalCount,
  clientList: state.clientDirectory.clientDirectoryList,

  loginData: state.auth.loginData,
});

const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetSchedulingError: () => dispatch(resetSchedulingError()),
  dispatchResetSchedulingSuccess: () => dispatch(resetSchedulingSuccess()),
  dispatchResetSchedulingMessage: () => dispatch(resetSchedulingMessage()),
  dispatchResetSchedulingStatusCode: () =>
    dispatch(resetSchedulingStatusCode()),
  dispatchResetClientUserSchedulingList: () =>
    dispatch(resetClientUserSchedulingList()),
  dispatchResetClientUserSchedulingListTotal: () =>
    dispatch(resetClientUserSchedulingListTotal()),
  dispatchGetClientUserSchedulingList: (
    data: GetClientUserSchedulingListPayloadType
  ) => dispatch(getClientUserSchedulingListAction(data)),
  dispatchGetAssignedClientsToUserAction: (
    data: GetAssignedClientsToUserPayloadType
  ) => dispatch(getAssignedClientsToUserAction(data)),
  dispatchGetAllClientAction: (data: getAllClientPayload) =>
    dispatch(getClientDirectoryListAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ClientVsUserScheduling);
